import { Paginated } from "../../../old/beheer/store/api/upsellApi";
import { apiRoot } from "../../../old/beheer/store/api/apiRoot";

const voucherDefinitionEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["VoucherDefinition"],
});

export type VoucherDefinition = { id: number; title: string; discountType: string };

export const voucherDefinitionApi = voucherDefinitionEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchVoucherDefinitions: builder.query<
      Paginated<VoucherDefinition>,
      {
        vestiging_id: number;
        pagination: {
          page: number;
          perPage: number;
        };
      }
    >({
      query: ({ vestiging_id, pagination: { page, perPage } }) => {
        return {
          url: `/voucher-definitions?filter[vestiging_id][]=${vestiging_id}&per_page=${perPage}&page=${page}`,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "VoucherDefinition" as const, id })),
              { type: "VoucherDefinition", id: "PARTIAL-LIST" },
            ]
          : [{ type: "VoucherDefinition", id: "PARTIAL-LIST" }],
    }),
  }),
});

export const { useFetchVoucherDefinitionsQuery } = voucherDefinitionApi;
